import React, {FC, useState} from 'react';
import {useLocation} from 'react-router-dom';
import FormPanel from '../../../components/FormPanel';
import ensureCsrfCookie from '../../../utils/ensureCsrfCookie';
import GradientHeading from '../components/GradientHeading';
import Page from '../components/Page';
import {
	Alert,
	AlertIcon,
	AlertTitle,
	Button,
	Center,
	FormControl,
	FormLabel,
	HStack,
	Input,
	PinInput,
	PinInputField,
} from 'components/ui/chakra';
import RegisterController from 'puddleglum/api/auth/RegisterController';

const VerifyEnrollment: FC = () => {
	const {state} = useLocation();
	const [errorText, setErrorText] = useState<string>();
	const [isLoading, setIsLoading] = useState(false);
	const [verificationCode, setVerificationCode] = useState<string>();

	const verifyUser = async () => {
		try {
			setErrorText(undefined);
			setIsLoading(true);
			await ensureCsrfCookie();
			await RegisterController.verifyCode({
				email: state.email ?? '',
				verification_code: verificationCode ?? '',
			});
			window.location.href = '/signup/complete';
		} catch (error: any) {
			setErrorText(
				error?.response?.data?.message ??
					'Unable to verify your enrollment right now. Please try again.',
			);
			setIsLoading(false);
		}
	};

	return (
		<Page>
			<Center w='100%' h='100vh'>
				<FormPanel
					description='Enter the verification code sent to your inbox to keep the signup secure.'
					minW={{base: '90%', md: '50%', lg: '40%'}}
				>
					<GradientHeading>Verify Enrollment</GradientHeading>
					{errorText && (
						<Alert status='error'>
							<AlertIcon />
							<AlertTitle>{errorText}</AlertTitle>
						</Alert>
					)}
					<FormControl id='email'>
						<FormLabel>Email</FormLabel>
						<Input type='email' value={state.email} isDisabled />
					</FormControl>
					<FormControl id='verification-code' mt={4}>
						<FormLabel>
							Enter the verification code we just sent to your email:
						</FormLabel>
						<HStack>
							<PinInput otp onChange={setVerificationCode}>
								<PinInputField />
								<PinInputField />
								<PinInputField />
								<PinInputField />
								<PinInputField />
								<PinInputField />
							</PinInput>
						</HStack>
					</FormControl>
					<HStack justifyContent='space-between' py={4}>
						<Button
							type='submit'
							colorScheme='blue'
							onClick={verifyUser}
							isLoading={isLoading}
						>
							Submit
						</Button>
					</HStack>
				</FormPanel>
			</Center>
		</Page>
	);
};

export default VerifyEnrollment;
